import { gql } from '@apollo/client';

export const FETCH_IPA_CONTRACT = gql`
  query Flex_FetchIpaContract($utilityAccountId: Int!) {
    signNowEnvelopeByUtilityAccount(
      utilityAccountId: $utilityAccountId
      contractType: "disclosure"
    ) {
      id
      status
      signingUrl
      inviteExpiresAt
      personalizedContractId
    }
  }
`;
